<template>
  <div>
    <div class="vrpano_wrapper" style="position:relative">
      <div
        v-show="loading"
        v-loading="loading"
        style="width: 100%; height: 100%; position: absolute !important"
      ></div>
      <Pano @on-load="onLoad" :source="urls[index]"></Pano>

      <button class="prevBtn" @click="prevVR()">
        <i class="el-icon-arrow-left" style="cursor: pointer"></i>
      </button>
      <button class="nextBtn" @click="nextVR()">
        <i class="el-icon-arrow-right" style="cursor: pointer"></i>
      </button>
    </div>
  </div>
</template>
<script>
import { Pano } from "vuejs-vr";
import { Loading } from "element-ui";
export default {
  components: {
    [Loading.name]: Loading,
    Pano
  },

  props: ["urls"],
  data() {
    return {
      index: 0,
      loading: true
    };
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
    nextVR() {
      if (this.urls.length > 1) {
        if (this.urls.length - 1 == this.index) {
          this.index = 0;
        } else {
          this.loading = true;
          this.index++;
        }
      }
    },
    prevVR() {
      if (this.urls.length > 1) {
        if (this.index == 0) {
          this.index = this.urls.length - 1;
        } else {
          this.loading = true;
          this.index--;
        }
      }
    }
  }
};
</script>
<style scoped>
.prevBtn,
.nextBtn {
  position: absolute;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, 0.11);
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
}
.prevBtn {
  left: 30px;
}
.nextBtn {
  right: 30px;
}
</style>
